import { Card, SxProps, Box, Stack, styled, CardActionArea, Typography, IconButton, Badge } from "@mui/material";
import React from "react";
import ActivtyHeadingTitle from "../ActivityHeading/activity-heading-title";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import AvatarProfilePicture from "../../Misc/AvatarProfilePicture/avatar-profile-picture";

export interface ActivityConversationProps {
  variant?: "success" | "warning" | "error" | "info" | "primary" | "secondary";
  label: string;
  action?: string;
  user: string;
  body: string;
  sx?: SxProps;
  selected?: boolean;
  onClick?: () => void;
  onClickDelete?: () => void;
  onClickEdit?: () => void;
  isOwner?: boolean;
  isRead?: boolean;
  userId?: number;
  firstName?: string;
  lastName?: string;
}

const ActivityConversation: React.FC<ActivityConversationProps> = (props) => {
  const {
    selected = false,
    variant,
    label,
    action,
    user,
    body,
    isOwner,
    isRead = false,
    userId,
    firstName,
    lastName,
    onClickDelete,
    onClickEdit,
    ...otherProps
  } = props;

  return (
    <StyledCard variant="outlined" selected={selected} {...otherProps}>
      <CardActionArea>
        {isRead ? (
          <AvatarProfilePicture userId={userId} userFirstName={firstName} userLastName={lastName} />
        ) : (
          <Badge color="info" variant="dot">
            <AvatarProfilePicture userId={userId} userFirstName={firstName} userLastName={lastName} />
          </Badge>
        )}
        <Stack direction={"row"} flex={1} justifyContent={"space-between"} spacing={2} ml={1.5}>
          <Stack spacing={0.5}>
            <ActivtyHeadingTitle variant={variant} label={label} action={action} user={user || body} />
            {user && (
              <Box>
                <Typography component="span" color="text.secondary">
                  {body}
                </Typography>
              </Box>
            )}
          </Stack>
          {isOwner && (
            <Stack justifyContent={"center"} direction="row" spacing={1}>
              <IconButton size="small" onClick={onClickDelete} className={"hide-button"}>
                <DeleteOutlinedIcon color="error" />
              </IconButton>
              <IconButton size="small" onClick={onClickEdit} className={"hide-button"}>
                <ModeEditOutlineOutlinedIcon />
              </IconButton>
            </Stack>
          )}
        </Stack>
      </CardActionArea>
    </StyledCard>
  );
};

const StyledCard = styled(Card, { shouldForwardProp: (prop) => prop !== "selected" })<{ selected?: boolean }>(
  ({ theme, selected }) => ({
    ".MuiCardActionArea-root": {
      padding: theme.spacing(1.5),
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    ".hide-button": {
      opacity: 0,
      transition: "opacity .3s",
    },
    ...(selected && {
      background: theme.palette.backgroundAlpha.hover,
      borderColor: "transparent",
    }),
    "&:hover": {
      ".MuiButtonBase-root": {
        opacity: 1,
      },
    },
  })
);

export default ActivityConversation;
